import type { ServiceResponse } from './types';
import { api } from '../utils/api';
import { API_ENDPOINTS } from '../config/api.config';

interface UploadResponse {
  url: string;
  filename: string;
  size: number;
  mimetype: string;
}

class UploadService {
  async uploadPaymentProof(file: File): Promise<ServiceResponse<UploadResponse>> {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.upload<UploadResponse>(
        API_ENDPOINTS.UPLOAD.PAYMENT_PROOF,
        formData
      );

      return {
        success: true,
        data: response
      };
    } catch (error) {
      console.error('Error uploading payment proof:', error);
      return {
        success: false,
        data: null as any,
        error: error instanceof Error ? error.message : 'Failed to upload payment proof'
      };
    }
  }

  async uploadProductImage(file: File): Promise<ServiceResponse<UploadResponse>> {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.upload<UploadResponse>(
        API_ENDPOINTS.UPLOAD.PRODUCT_IMAGE,
        formData
      );

      return {
        success: true,
        data: response
      };
    } catch (error) {
      console.error('Error uploading product image:', error);
      return {
        success: false,
        data: null as any,
        error: error instanceof Error ? error.message : 'Failed to upload image'
      };
    }
  }
}

export const uploadService = new UploadService();